<template>
	<div>
		<div class="answer-block">
			<h1 role="alert" aria-live="assertive" tabindex="0" class="ada-focus">{{ title }}</h1>

			<v-card v-if="_.size(book)">
				<v-card-text>
					<v-layout>
						<v-flex xs2>
							<v-img :src="book.cover" height="125px" max-width="80%"></v-img>
						</v-flex>
						<v-flex xs10>
							<div>
								<strong>{{ book.title }}</strong><span v-if="book.author">, {{ book.author }}</span>
							</div>
							<div>
								<strong>ISBN:</strong>
								<span>{{ book.isbn }}</span>
							</div>
							<div v-if="total_tax">
								<v-divider></v-divider>
								<p v-html="tax_message"></p>
							</div>
						</v-flex>
					</v-layout>
				</v-card-text>
			</v-card>

			<p>
				If you think you shouldn't have been charged sales tax, please contact us using the form below.
			</p>

			<email-form
					caption="Contact Us"
					:subject="title"
					:body="email_body"
					on-success-url="/help?#/submitted"
					edit-body
					must-edit
					:payload="{ order_line_id }"
					destination-key="ge"
			></email-form>

		</div>

		<base-nav-links></base-nav-links>
	</div>
</template>

<script>
	import BaseNavLinks from './../components/BaseNavLinks';
	import EmailForm from './../components/EmailForm';
	import Axios from 'axios';
	import _ from 'lodash';

	export default {
		name: "WhyChargedTax",

		components: {
			BaseNavLinks,
			EmailForm,
		},

		data() {
			return {
				title: 'Why did I get charged sales tax?',
				order_line_id: parseInt(this.$route.params.id) || 0,
				book: {},
				taxes: {},
			};
		},

		computed: {
			_() {
				return _;
			},

			total_tax() {
				return _.sum(_.values(this.taxes));
			},

			tax_message() {
				const taxes = [];
				var message = `The tax rate for the item is <strong>$${this.total_tax.toFixed(2)}</strong>`;

				_.each(this.taxes, (value, key) => {
					if (value > 0) taxes.push(`${_.lowerCase(key)} $${value.toFixed(2)}`);
				});

				if (taxes.length > 1) {
					message += ', which includes ' + this.join(taxes);
				}

				return `${message}.`;
			},

			email_body() {
				return `I believe I shouldn’t have been charged sales tax on my order: \n`;
			},
		},

		methods: {
			join(array, each = ', ', last = ' and ') {
				if (!array.length) return '';
				else if (array.length === 1) return array[0];
				else if (array.length === 2) return array.join(last);
				else return array.slice(0, -1).join(each) + last + array.slice(-1);
			},
		},

		mounted() {
			Axios.get('/service/customer_help/rest/index.php/customer_help/get_item_sales_taxes/' +
				this.order_line_id
			).then(response => {
				if (response.data.status === 'success' && (response = response.data.data)) {
					this.book = response.book;
					_.each(response.taxes, (value, key) => {
						this.taxes[key] = _.round(value, 2);
					});
				}
			});
		},
	}
</script>

<style scoped lang="less">
	.v-card {
		font-size: 12pt;

		.v-divider {
			margin: 10px 0;
		}
	}
</style>